<template>
	<div>
		<div class="secure-password-animation__display">
			<helio-icon
				class="secure-password-animation__icon"
				token="check"
				color="white"
			/>
			<div class="secure-password-animation__text">
				{{ translation['modified-password'] }}
			</div>
		</div>
		<div class="secure-password-animation secure-password-animation__expand" />
	</div>
</template>

<script>
import { translationMixin } from '@/mixins';

export default {
	name: 'SecurePasswordAnimation',
	mixins: [translationMixin],
	computed: {
		translation() {
			return this.currentTranslation['secure-password-animation'];
		},
	},
};
</script>

<style scoped lang="scss" src="./secure-password-animation.scss" />
